var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cssVars)},[(_vm.cLabel)?_c('label',{staticClass:"text-caption labelColor"},[_vm._v(_vm._s(_vm.cLabel))]):_vm._e(),_c('v-text-field',_vm._g(_vm._b({staticClass:"mt-1",class:_vm.changed ? 'changed' : '',attrs:{"outlined":""}},'v-text-field',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }